import { combineReducers } from "redux";

export const createRootReducer = (injectReducers: any = {}) => {
  return combineReducers({
    ...injectReducers,
  });
};
